import React, { useState } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { PlusIcon, XIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-[#CCCCCC] py-4" data-id="element-2320">
      <button className="w-full flex items-center justify-between text-left py-2 focus:outline-none group min-h-[48px]" onClick={onClick} data-id="element-2321">
        <span className="text-black font-bold text-lg font-[Poppins,_sans-serif] pr-8 group-hover:text-[#FF1493] transition-colors" data-id="element-2322">
          {question}
        </span>
        <span className="text-[#FF1493] flex-shrink-0 transition-transform duration-300" data-id="element-2323">
          {isOpen ? <XIcon size={24} data-id="element-2324" /> : <PlusIcon size={24} data-id="element-2325" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-2326">
        <p className="text-[#333333] text-base font-body leading-[1.7] pt-4 pb-2" data-id="element-2327">
          {answer}
        </p>
      </div>
    </div>;
}
export function WRFAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    question: 'Am I A Good Candidate For Wrinkle Relaxers?',
    answer: 'The best candidates for Botox, Dysport and Xeomin are in good overall health and have moderate to severe facial wrinkles or folds in areas that injectables can treat, like around or between the eyes, the forehead, the neck and mouth.'
  }, {
    question: 'What Are The Benefits Of Botox?',
    answer: 'Botox, like most injectables, is used to restore a youthful appearance to the face or neck and treat issues like fine lines, wrinkles, and folds. In addition, Botox is used to minimize muscle activity and delay the signs of aging.'
  }, {
    question: 'What Can I Expect During Treatment?',
    answer: 'During treatment, which usually takes about 10-20 minutes, your provider will inject the most suitable wrinkle relaxer into the target area(s). You may notice temporary swelling at injection site, but it typically subsides quickly.'
  }, {
    question: 'What Is Recovery Like? Are There Any Side Effects?',
    answer: 'The appeal of cosmetic injections like Botox, Dysport and Xeomin is that it provides quick results with virtually no recovery period which is why it is often referred to as a “lunch-time treatment”. However, just like any medical treatment, each patient might respond differently. Although the odds of having an adverse reaction are very low, our medical staff will explain all the risks and possible side effects before you undergo treatment.'
  }, {
    question: 'How Many Treatments Should I Get?',
    answer: 'The number of treatments needed and the frequency of those treatments depend on your body chemistry, medical history, and desired results. Like most injectable treatments, wrinkle relaxers are part of an ongoing beauty regimen, which means it isn’t a permanent solution and will require follow-up visits which is typically every 3-4 months.'
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-2328">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-2329">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-2330">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-2331">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-2332"></div>
        </AnimateOnScroll>

        <AnimateOnScroll delay={200} data-id="element-2333">
          <div className="space-y-2" data-id="element-2334">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-2335" />)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}